const RESET_REQUEST = 'dofe-web/passwords/RESET_REQUEST'
const RESET_REQUEST_SUCCESS = 'dofe-web/passwords/RESET_REQUEST_SUCCESS'
const RESET_PASSWORD = 'dofe-web/passwords/RESET_PASSWORD'
const RESET_PASSWORD_SUCCESS = 'dofe-web/passwords/RESET_PASSWORD_SUCCESS'
const RESET_FAIL = 'dofe-web/passwords/RESET_FAIL'
const CONFIRM_ORG_CONTACT_REGISTRATION = 'dofe-web/passwords/CONFIRM_ORG_CONTACT_REGISTRATION'
const CONFIRM_ORG_CONTACT_REGISTRATION_SUCCESS = 'dofe-web/passwords/CONFIRM_ORG_CONTACT_REGISTRATION_SUCCESS'
const CONFIRM_ORG_CONTACT_REGISTRATION_FAIL = 'dofe-web/passwords/CONFIRM_ORG_CONTACT_REGISTRATION_FAIL'

const initialState = {
  loading: false,
  loaded: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case RESET_REQUEST:
      return {
        ...state,
        loading: true
      }
    case RESET_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case RESET_PASSWORD:
      return {
        ...state,
        loading: true
      }
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case RESET_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case CONFIRM_ORG_CONTACT_REGISTRATION:
      return {
        ...state,
        loading: true
      }
    case CONFIRM_ORG_CONTACT_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case CONFIRM_ORG_CONTACT_REGISTRATION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function resetRequest(email) {
  return {
    types: [RESET_REQUEST, RESET_REQUEST_SUCCESS, RESET_FAIL],
    promise: client =>
      client.post('api/passwords/reset-request?host=FO', {
        removeToken: true,
        data: {
          value: email
        }
      })
  }
}

export function resetPassword(data, authorizationCode) {
  return {
    types: [RESET_PASSWORD, RESET_PASSWORD_SUCCESS, RESET_FAIL],
    promise: client =>
      client.post(
        `api/person/password-set/using-authorization-code?authorizationCode=${authorizationCode}`,
        {
          removeToken: true,
          data
        }
      )
  }
}

export function confirmOrganizationContactRegistration(data, authorizationCode) {
  return {
    types: [CONFIRM_ORG_CONTACT_REGISTRATION, CONFIRM_ORG_CONTACT_REGISTRATION_SUCCESS, CONFIRM_ORG_CONTACT_REGISTRATION_FAIL],
    promise: client =>
      client.post(
        `api/organization-contact-registrations/confirm/using-authorization-code?authorizationCode=${authorizationCode}`,
        {
          removeToken: true,
          data
        }
      )
  }
}

